export const FACILITY_TYPES: any[] = [
  { ID: 'ADC', Name: 'ADC' },
  { ID: 'BASE', Name: 'BASE' },
  { ID: 'HC', Name: 'Home Care' },
  { ID: 'TC', Name: 'Telecare' },
  { ID: 'A2C', Name: 'A2C' },
  { ID: 'MEALS', Name: 'MEALS' },
];
